import axiosInstance from "../axiosInstance";
import APIPaths from "../../utils/APIPaths";
import { toast } from "react-toastify";

export const getAddressListAPI = async () => {
  const response = await axiosInstance.get(APIPaths.GET_ADDRESS_AND_TIMING);

  if (response.status === 200) {
    return response.data;
  } else {
    return [];
  }
};

export const getTimingListAPI = async (id) => {
  const response = await axiosInstance.get(APIPaths.GET_TIMING_LIST + id);

  if (response.status === 200) {
    return response.data;
  } else {
    return [];
  }
};

export const postAddressAPI = async (bodyObj) => {
  const response = axiosInstance
    .post(APIPaths.POST_ADD_ADDRESS_AND_TIMING, bodyObj)
    .then((response) => {
      if (response.status === 201) {
        toast.success("Address added successfully.");
        return response;
      } else {
        toast.error("Something went wrong.");
        return response;
      }
    })
    .catch((error) => {
      if (error.response.data.errors) {
        for (const item in error.response.data.errors) {
          toast.error(error.response.data.errors[item]);
        }
      } else {
        toast.error(error.response.data);
      }
      return error;
    });
  return response;
};

export const putAddressAndTimingAPI = async (id, bodyObj) => {
  const response = await axiosInstance
    .put(`${APIPaths.PUT_UPDATE_ADDRESS_AND_TIMING}${id}`, bodyObj)
    .then((response) => {
      if (response.status === 201) {
        toast.success("Address updated successfully.");
        return response;
      } else {
        toast.error("Something went wrong.");
        return response;
      }
    })
    .catch((error) => {
      if (error.response.data.errors) {
        for (const item in error.response.data.errors) {
          toast.error(error.response.data.errors[item]);
        }
      } else {
        toast.error(error.response.data);
      }
      return error;
    });
  return response;
};

export const deleteAddressAPIHandler = async (addressID) => {
  return axiosInstance
    .delete(APIPaths.DELETE_ADDRESS + addressID)
    .then((response) => {
      if (response.status === 200) {
        toast.success("Address deleted successfully.");
        return response.data;
      } else {
        toast.error("Something went wrong.");
        return null;
      }
    })
    .catch((error) => {
      if (error.response?.data?.message) {
        toast.error(error.response?.data?.message);
      } else {
        toast.error("Something went wrong.");
      }

      return null;
    });
};

export const getCountryList = async () => {
  const response = await axiosInstance.get(APIPaths.GET_COUNTRY_LIST);
  return response.data;
};

export const getStateList = async (currentCountry) => {
  const response = await axiosInstance.get(`${APIPaths.GET_STATES_LIST}`, {
    params: {
      countryName: currentCountry,
    },
  });
  return response.data;
};

export const getDaysOfWeek = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_DAYS_OF_WEEK);
    return response.data;
  } catch (error) {
    return [];
  }
};
